import {Routes} from '@angular/router';
import {LoginComponent} from './auth/login/login.component';
import {IsNotLoggedInGuard} from './guards/is-not-logged-in.guard';
import {ForgotPasswordComponent} from './auth/forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './auth/reset-password/reset-password.component';
import {RegisterComponent} from './auth/register/register.component';
import {routes as authenticatedRoutes} from './authenticated/authenticated.routes'
import {IsLoggedInGuard} from './guards/is-logged-in.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [IsNotLoggedInGuard],
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [IsNotLoggedInGuard],
  },
  {
    path: 'password-reset/:token',
    component: ResetPasswordComponent,
    canActivate: [IsNotLoggedInGuard],
  },
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [IsNotLoggedInGuard],
  },
  {
    path: '',
    canActivate: [IsLoggedInGuard],
    children: authenticatedRoutes,
  },
  {
    // Catch-all for unknown routes. Redirects to '' which is guarded by
    // IsLoggedInGuard: logged-in users land on the authenticated home,
    // unauthenticated users get bounced to /login by the guard.
    path: '**',
    redirectTo: '',
  },
];
